export default {
      id: "instagram-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }